// removed by extract-text-webpack-plugin
module.exports = {"Builder":"BurgerBuilder__Builder__3fLiv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/BurgerBuilder/BurgerBuilder.css
// module id = 56
// module chunks = 0